/**
 * all actions for investment state
 *
 * Created by Tom on 16/06/18
 */

import C from '../constants'


// action to hide/show the loader for the investment
export const showInvestmentLoader = booleanVal => {
    return {
        type: C.SET_INVESTMENT_LOADER,
        payload: booleanVal
    }
}

// action to set the investment data
export const setInvestmentData = objectVal => {
    return {
        type: C.SET_INVESTMENT_DATA,
        payload: objectVal
    }
}

// action to set the investment fetch success state
export const setInvestmentFetchSuccess = booleanVal => {
    return {
        type: C.SET_INVESTMENT_FETCH_SUCCESS,
        payload: booleanVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the investment saga (sagas/investmentSaga.js)
export const getInvestmentData = () => {
    return {
        type: C.FETCH_INVESTMENT_DATA
    }
}



// WEBPACK FOOTER //
// ./src/actions/investmentActions.js